import { render, staticRenderFns } from "./DAProfessionalProfile.vue?vue&type=template&id=707d3dcc"
import script from "./DAProfessionalProfile.vue?vue&type=script&lang=js"
export * from "./DAProfessionalProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports